<template>
  <div>
    <br class="hidden-xs-only" />
    <div class="kongxi hidden-sm-and-up"></div>
    <el-card shadow="always" :body-style="{ padding: '20px' }">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/news' }">新闻动态</el-breadcrumb-item>
        <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <h2>世界害虫日｜守护健康，从“虫”容应对开始</h2>
        <div id="meta_content">
          <span class="rich_b"> 东进防控 </span>
          <span id="rich_c">
            <span>2025-06-04 16:17</span>
            广东
          </span>
        </div>
        <p>
          6月4日，一场关乎全民健康的特别活动在莞城街道人民公园拉开帷幕。在第九个“世界害虫日”到来之际，由东莞市多部门联合主办的“绿色虫控，健康家园”主题宣传活动，为市民带来了一场别开生面的健康科普盛宴。
        </p>
        <img width="100%" :src="img[0]" alt="" />
        <p>
          出席此次活动的嘉宾有：东莞市卫生健康局爱国卫生管理科温玉麟科长与王术聪副科长、东莞市疾控中心消媒科黄振宇科长，莞城街道卫健局李秋燕局长、陆冠锦副局长、东实集团广东东进有害生物防控技术有限公司朱雷董事长、王伟总经理、广东东鸿物业发展有限公司梁晓辉总经理助理、东莞市有害生物防制协会程强会长，还有来自疾控中心、城管、协会等多个部门的专业人士与代表。
        </p>
        <img width="100%" :src="img[1]" alt="" />
        <img width="100%" :src="img[2]" alt="" />
        <img width="100%" :src="img[3]" alt="" />
        <img width="100%" :src="img[4]" alt="" />
        <p>
           活动伊始，温玉麟科长、朱雷董事长、程强会长分别发表致辞。随后，举行了世界害虫日标识物传递仪式。嘉宾依次登台，共同见证并参与这一极具特殊意义的时刻。印刻着“6月6日世界害虫日”字样的盾牌，承载着沉甸甸的责任与坚定不移的信念，此次传递仪式正式宣告一场关乎公共卫生安全的“守护者接力”行动全面开启。
        </p>
        <p>
          活动现场设置了丰富的科普展板和除虫灭鼠展示区。这些展板图文并茂，详细展示了各类害虫图谱、生活习性、危害实例、防制方法以及用药安全警示等内容。市民们纷纷移步展区，深入了解害虫防制的相关知识，进一步增强了对科学防制害虫的认识和掌握。
        </p>
        <img width="100%" :src="img[5]" alt="" />
        <p>
           活动现场另一侧，东进公司员工献血活动爱意满满！众多员工满怀无私奉献精神，在医务人员引导下完成登记、检测等流程后，纷纷挽起袖管献血，用行动诠释责任，为生命送去希望，尽显关爱社会的良好形象。
        </p>
        <p>
          现场还设置了义诊专区。来自莞城医院、莞城社区卫生服务中心、健力口腔医院的专家们，为市民进行免费的健康检查。不少市民纷纷排队咨询，专家们一一给予详细解答。中医师在现场施展传统医学的魅力，为市民进行中医义诊，通过望闻问切，为市民诊断身体状况，并提供中医养生建议。口腔医生们也不甘示弱，他们为过往市民检查口腔健康，从日常刷牙的正确方式，到龋齿、牙周炎等常见口腔疾病的防治，都进行了专业科普。
        </p>
        <p>
           同时，莞城卫健局主题党日活动也热闹非凡！他们联同东进公司党员借世界害虫日宣传活动，向市民发放资料、现场讲解，普及害虫防治知识与党的健康卫生政策。传递党的关怀，增强党组织凝聚力与影响力。
        </p>
        <img width="100%" :src="img[6]" alt="" />

        <p>
          世界害虫日，是提醒，更是行动的号角！东进做为专业的病媒生物防控公司将一起与大家“虫”容应对，畅享健康生活。
        </p>
        <h3>我们还提供多元化服务</h3>
        <img width="100%" :src="img[7]" alt="" />
        <h3>扫码关注我们了解更多</h3>
        <div>
          <img :src="img[8]" alt="" />
        </div>
      </div>
      <br />
      <br />
      <el-row :gutter="20">
        <el-col :span="12" :xs="24" :offset="0">
          <span>&nbsp;</span>
        </el-col>
        <el-col
          :span="12"
          :xs="24"
          :offset="0"
          style="text-align: right"
          class="hidden-xs-only"
        >
          <span
            style="cursor: pointer; color: #666; font-size: 14px"
            @click="$router.push({ name: 'News13' })"
            >登革热防治技能深度培训：提...&nbsp;&nbsp;&nbsp;&nbsp;下一条 &gt;</span
          >
        </el-col>
      </el-row>
      <br />
      <br />
    </el-card>
    <br class="hidden-xs-only" />
    <div class="kongxi hidden-sm-and-up"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      img: [
        require("@/assets/news14_1.jpg"),
        require("@/assets/news14_2.jpg"),
        require("@/assets/news14_3.jpg"),
        require("@/assets/news14_4.jpg"),
        require("@/assets/news14_5.jpg"),
        require("@/assets/news14_6.jpg"),
        require("@/assets/news14_7.jpg"),
        require("@/assets/news8-4.png"),
        require("@/assets/news8-7.png"),
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.black {
  font-weight: 700;
}

.kongxi {
  height: 10px;
}

.big-div {
  display: flex;
  justify-content: space-evenly;
}

.small-div {
  text-align: center;
}

.small-div1 img {
  width: 258px;
  height: 258px;
}

.small-div2 img {
  width: auto;
  height: auto;
}

.caption {
  font-size: 14px;
  margin-top: 10px;
  text-align: center;
}

.content {
  width: 90%;
  margin: 0 auto;

  h2 {
    font-family: 黑体, SimHei;
    font-size: 24px;
    margin: 20px 0;
    text-align: center;
  }

  h3 {
    font-weight: normal;
    font-family: 黑体, SimHei;
    font-size: 18px;
    margin: 20px 0;
    text-align: left;
  }

  p {
    font-size: 16px;
    margin: 20px 0;
    text-align: justify;
    text-indent: 2em;
    color: #515050;
    font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
  }
}

.wenzi {
  margin: 0 !important;
  color: rgb(255, 255, 255) !important;
}

@media screen and (max-width: 768px) {
  .content {
    width: 90%;
    margin: 0 auto;

    h2 {
      margin: 20px 0;
      text-align: center;
      font-size: 24px;
    }

    h3 {
      font-size: 18px;
      margin: 20px 0;
      text-align: left;
    }

    p {
      margin: 10px 0;
      text-align: justify;
      text-indent: 2em;
      font-size: 16px;
      color: #515050;
      font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
    }
  }
}

#meta_content {
  font-size: 15px;
  padding-left: 2.6em;

  span {
    color: rgba(0, 0, 0, 0.3);
  }

  .rich_b {
    color: #576b95 !important;
  }
}
</style>
